import { toast } from "sonner";
import { ApiGroupResponse, GroupDetails, GroupParams } from "../types/groupAndHouses";
import customFetch from "../util/config/axiosConfig";

const GroupApis = {
  // GET all
  getGroups: async (
    params: GroupParams,
  ): Promise<ApiGroupResponse | undefined> => {
    try {
      const response = await customFetch.get("/api/v1/student-group", {
        params: {
          branchCode: params.branchCode,
          page: params.page,
          size: params.size,
          name: params.name || "", // search filter
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching groups:", error);
      toast.error("Error fetching groups.");
      throw error;
    }
  },

  // DELETE group by ID
  deleteGroup: async (groupId: number): Promise<ApiGroupResponse> => {
    try {
      const response = await customFetch.delete(
        `/api/v1/student-group/${groupId}`,
      );

      if (response.data.status === 1) {
      } else {
        toast.error("Failed to delete group.");
      }

      return response.data;
    } catch (error) {
      console.error("Error deleting group:", error);
      toast.error("Error deleting group.");
      throw error;
    }
  },

  // POST
  createGroup: async (
    groupName: string,
    branchCode: string,
    studentIds: number[],
    staffIds: number[],
  ): Promise<ApiGroupResponse> => {
    try {
      const params = new URLSearchParams();

      params.append("groupName", groupName);
      params.append("branchCode", branchCode);

      studentIds.forEach((id) => params.append("studentIds", String(id)));
      staffIds.forEach((id) => params.append("staffIds", String(id)));

      const response = await customFetch.post(
        `/api/v1/student-group?${params.toString()}`,
        {},
      );

      if (response.data.status === 1) {
        toast.success("Group created successfully!");
      } else {
        toast.error("Failed to create group.");
      }

      return response.data;
    } catch (error) {
      console.error("Error creating group:", error);
      toast.error("Error creating group.");
      throw error;
    }
  },

  // GET group by ID
  getGroupById: async (groupId: number): Promise<GroupDetails | undefined> => {
    try {
      const response = await customFetch.get(
        `/api/v1/student-group/${groupId}`,
      );

      if (response.data.status === 1) {
        return response.data.data;
      } else {
        toast.error("Failed to fetch group details.");
      }
    } catch (error) {
      console.error("Error fetching group by ID:", error);
      toast.error("Error fetching group details.");
      throw error;
    }
  },

  // PUT: Update group
  updateGroup: async (
    groupId: number,
    groupName: string,
    branchCode: string,
    studentIds: number[],
    staffIds: number[],
  ): Promise<ApiGroupResponse> => {
    try {
      const params = new URLSearchParams();

      params.append("groupId", String(groupId));
      params.append("groupName", groupName);
      params.append("branchCode", branchCode);

      studentIds.forEach((id) => params.append("studentIds", String(id)));
      staffIds.forEach((id) => params.append("staffIds", String(id)));

      const response = await customFetch.put(
        `/api/v1/student-group?${params.toString()}`,
        {},
      );

      if (response.data.status === 1) {
        toast.success("Group updated successfully!");
      } else {
        toast.error("Failed to update group.");
      }

      return response.data;
    } catch (error) {
      console.error("Error updating group:", error);
      toast.error("Error updating group.");
      throw error;
    }
  },

  // PATCH: Add student to group
  addStudentToGroup: async (
    groupId: number,
    admissionNumber: number,
  ): Promise<ApiGroupResponse> => {
    try {
      const response = await customFetch.patch(
        `/api/v1/student-group/add-student/${groupId}`,
        admissionNumber,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.status === 1) {
      } else {
        toast.error("Failed to add student to group.");
      }

      return response.data;
    } catch (error) {
      console.error("Error adding student to group:", error);
      toast.error("Error adding student to group.");
      throw error;
    }
  },

  removeStudent: async (
    groupId: number,
    studentId: number,
  ): Promise<ApiGroupResponse> => {
    try {
      const response = await customFetch.delete(
        `/api/v1/student-group/remove-student/${groupId}`,
        {
          data: studentId,
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.status !== 1) {
        toast.error("Failed to remove student from group.");
      }

      return response.data;
    } catch (error) {
      console.error("Error removing student from group:", error);
      toast.error("Error removing student from group.");
      throw error;
    }
  },
};

export default GroupApis;
